const development = {
    host: {
        api: "https://sx7bqjcob9.execute-api.ap-northeast-2.amazonaws.com/dev"
        // api: "https://1iendvrgl5.execute-api.ap-northeast-2.amazonaws.com/sm" //sm
        // api: "https://q6m7cv6mk8.execute-api.ap-northeast-2.amazonaws.com/blossomme" // blossomme
    }
};

export default development;